var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartsTab4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9112 12.0112L23.5903 10.3321L28.3371 15.0789L26.658 16.758L21.9112 12.0112ZM24.8538 7.91669C26.3817 7.91669 27.6246 6.67377 27.6246 5.14585C27.6246 4.68669 27.4979 4.25919 27.3 3.87919L25.1625 6.01669L23.9829 4.8371L26.1204 2.6996C25.7404 2.50169 25.3129 2.37502 24.8538 2.37502C23.3259 2.37502 22.0829 3.61794 22.0829 5.14585C22.0829 5.47044 22.1463 5.77919 22.2492 6.06419L20.7846 7.52877L19.3754 6.1196L19.9375 5.55752L18.8213 4.44127L20.4996 2.76294C20.0543 2.31818 19.4507 2.06836 18.8213 2.06836C18.1919 2.06836 17.5883 2.31818 17.1429 2.76294L14.3404 5.56544L15.4567 6.68169H13.2242L12.6621 7.24377L15.4646 10.0463L16.0267 9.48419V7.24377L17.1429 8.36002L17.705 7.79794L19.1142 9.2071L13.2479 15.0734L14.9263 16.7517L23.9354 7.75044C24.2204 7.85335 24.5292 7.91669 24.8538 7.91669Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19V24C13 24.2652 13.1054 24.5196 13.2929 24.7071C13.4804 24.8946 13.7348 25 14 25H20.102C20.2345 25 20.3657 25.0264 20.4879 25.0775C20.6101 25.1287 20.721 25.2036 20.814 25.298L21.712 26.208C21.8965 26.3951 22 26.6473 22 26.91V30C22 30.2652 21.8946 30.5196 21.7071 30.7071C21.5196 30.8946 21.2652 31 21 31H18",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 31H3C2.73478 31 2.48043 30.8946 2.29289 30.7071C2.10536 30.5196 2 30.2652 2 30V21C2 20.4696 2.21071 19.9609 2.58579 19.5858C2.96086 19.2107 3.46957 19 4 19H16C17.1 19 18.1 19.8 18.4 20.8L19.576 25M9 31H14",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 33C17.1046 33 18 32.1046 18 31C18 29.8954 17.1046 29 16 29C14.8954 29 14 29.8954 14 31C14 32.1046 14.8954 33 16 33Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 33C8.10457 33 9 32.1046 9 31C9 29.8954 8.10457 29 7 29C5.89543 29 5 29.8954 5 31C5 32.1046 5.89543 33 7 33Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartsTab4);
export default __webpack_public_path__ + "static/media/parts-tab-4.b67064e9dde08811d36a1f36f81a89cd.svg";
export { ForwardRef as ReactComponent };